export default __webpack_public_path__ + "static/media/basen.b11e96fd.png";